(function () {
  var labels = {
    'Para iade politikası': 'Refund policy',
    'Para iade politikasi': 'Refund policy',
    'İletişim bilgileri': 'Contact information',
    'Iletisim bilgileri': 'Contact information',
    'Yasal bildirim': 'Legal notice',
    'Ürünler': 'Products',
    'İletişim': 'Contact',
    'Iletisim': 'Contact',
    'Hesap': 'Account',
    'Ana sayfa': 'Home',
    'Katalog': 'Catalog',
    'Gizlilik politikası': 'Privacy policy',
    'Gizlilik politikasi': 'Privacy policy',
    'Kargo politikası': 'Shipping policy',
    'Mağazam': 'Rexven Print Factory',
    'Alışveriş Sepetiniz': 'Your cart',
    'Giriş yapın veya hesap oluşturun': 'Sign in or create an account',
    'Giriş yap veya hesap oluştur': 'Sign in or create an account',
    'Menüyü kapat': 'Close menu',
    'Giriş yap': 'Sign in',
    'Hesap oluştur': 'Create account',
    'E-posta': 'Email',
    'E-posta adresi': 'Email',
    'Devam et': 'Continue',
    'Google ile devam et': 'Continue with Google',
    'Shop ile devam et': 'Continue with Shop',
    'Facebook ile devam et': 'Continue with Facebook',
    'Alaka': 'Relevance',
    'Fiyat, düşükten yükseğe': 'Price, low to high',
    'Fiyat, yüksekten düşüğe': 'Price, high to low',
    'Fiyat': 'Price',
    'Sayfa bulunamadı': 'Page not found',
  };

  var keys = Object.keys(labels).sort(function (a, b) {
    return b.length - a.length;
  });

  function applyStoreLocale() {
    if (window.Shopify) {
      Shopify.locale = 'en';
      Shopify.country = 'US';
    }
    window.zakekeShopLocales = [{ iso_code: 'en', root_url: '/', primary: true }];
    document.documentElement.lang = 'en';
    document.querySelectorAll('shopify-store').forEach(function (el) {
      el.setAttribute('language', 'EN');
      el.setAttribute('country', 'US');
    });
    document.querySelectorAll('shopify-account').forEach(function (el) {
      el.setAttribute('aria-label', 'Account');
    });
  }

  function englishZakekeUrl(src) {
    if (!src || src.indexOf('zakeke') === -1) return src;
    return String(src)
      .replace(/([?&](?:culture|locale|lang|language)=)tr(?:-[A-Za-z]+)?/gi, '$1en');
  }

  function fixZakekeFrames(root) {
    (root || document).querySelectorAll('iframe[src*="zakeke"]').forEach(function (frame) {
      var current = frame.src;
      var next = englishZakekeUrl(current);
      if (next && next !== current) frame.src = next;
    });
  }

  function watchZakekeLocale() {
    if (window.__rexvenZakekeWatch) return;
    window.__rexvenZakekeWatch = true;
    fixZakekeFrames(document);
    new MutationObserver(function () {
      fixZakekeFrames(document);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  function swap(text) {
    if (!text) return text;
    var next = text;
    keys.forEach(function (key) {
      if (next.indexOf(key) !== -1) next = next.split(key).join(labels[key]);
    });
    return next;
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === 1) {
      ['aria-label', 'title', 'placeholder', 'alt'].forEach(function (attr) {
        var value = root.getAttribute && root.getAttribute(attr);
        if (!value) return;
        var updated = swap(value);
        if (updated !== value) root.setAttribute(attr, updated);
      });
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) {
        var updated = swap(node.nodeValue);
        if (updated !== node.nodeValue) node.nodeValue = updated;
      } else if (node.nodeType === 1) {
        ['aria-label', 'title', 'placeholder', 'alt'].forEach(function (attr) {
          var value = node.getAttribute(attr);
          if (!value) return;
          var next = swap(value);
          if (next !== value) node.setAttribute(attr, next);
        });
        if (node.shadowRoot) translateTree(node.shadowRoot);
      }
    }
  }

  function observeAccount(el) {
    if (!el || el.dataset.rexvenEnObserved) return;
    el.dataset.rexvenEnObserved = 'true';
    var observeRoot = function (root) {
      if (!root) return;
      translateTree(root);
      new MutationObserver(function () {
        translateTree(root);
      }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'placeholder'] });
    };
    observeRoot(el);
    if (el.shadowRoot) observeRoot(el.shadowRoot);
  }

  function swapTitle(text) {
    if (!text) return text;
    var next = text
      .replace(/^Alışveriş Sepetiniz/, 'Your cart')
      .replace(/^Arama:\s*"([^"]*)"\s*için\s*(\d+)\s*sonuç bulundu/i, 'Search: $2 results for "$1"')
      .replace(/^Arama/, 'Search')
      .replace(/^Sayfa bulunamadı/, 'Page not found');
    return swap(next);
  }

  function run() {
    applyStoreLocale();
    watchZakekeLocale();
    translateTree(document.body);
    document.querySelectorAll('shopify-account').forEach(observeAccount);
    var title = swapTitle(document.title);
    if (title !== document.title) document.title = title;
  }

  applyStoreLocale();
  watchZakekeLocale();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-store').then(run).catch(function () {});
    customElements.whenDefined('shopify-account').then(run).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
